import { ref, watch } from 'vue'

const isDarkMode = ref(false)

// Inicializar baseado na preferência salva ou preferência do sistema
const initializeDarkMode = () => {
  const savedPreference = localStorage.getItem('darkMode')
  
  if (savedPreference !== null) {
    // Use preferência salva
    isDarkMode.value = savedPreference === 'true'
  } else {
    // Use preferência do sistema
    isDarkMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches
  }
  
  // Aplicar classe no documento
  updateDocumentClass()
}

// Atualizar classe no documento
const updateDocumentClass = () => {
  if (isDarkMode.value) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}

// Observar mudanças e salvar preferência
watch(isDarkMode, (newValue) => {
  localStorage.setItem('darkMode', newValue.toString())
  updateDocumentClass()
})

export const useDarkMode = () => {
  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value
  }

  return {
    isDarkMode,
    toggleDarkMode,
    initializeDarkMode
  }
}